import { CommentCodesTransferModel, ListResponseModel, QueryParamModel } from 'models';
import { EntityService } from 'utils/entityService';
import { Mock } from 'utils/mockDecorator';
import { mockListResponse } from 'mock/list';
import request, { Methods } from 'utils/request';

class CommentCodesTransferService extends EntityService {
  constructor() {
    super('admin/leo-comment-code');
  }

  @Mock((params: QueryParamModel) =>
    import('mock/commentCodesTransfer').then((m) =>
      mockListResponse(m.MOCK_COMMENT_CODES_TRANSFER, params)
    )
  )
  async getList(params?: QueryParamModel | null) {
    return request<ListResponseModel<CommentCodesTransferModel>>({
      method: Methods.GET,
      resource: this.resource,
      params,
    });
  }

  @Mock(() => ({ id: Date.now() }))
  async sync() {
    return request({
      method: Methods.POST,
      resource: this.resource,
    });
  }
}

export const commentCodesTransferService = new CommentCodesTransferService();
